import React, { useEffect, useState } from 'react';
import { InputNumber } from 'antd';

const Selling = ({
  usersPricelist,
  routesChanges,
  setRoutesChanges,
  isMultiselector,
  userIdEditing,
  selling,
  row
}) => {
  const [localPrice, setLocalPrice] = useState(selling);

  // Solo sincroniza si el valor externo ha cambiado REALMENTE (nuevo row o valor de entrada)
  useEffect(() => {
    const updatedPrice = routesChanges.find(
      r => r.userId === row.userId && r.mccmnc === row.mccmnc
    )?.price;
  
    if (updatedPrice !== undefined && updatedPrice !== localPrice) {
      setLocalPrice(updatedPrice);
    }
  
    if (
      updatedPrice === undefined &&
      selling !== localPrice
    ) {
      setLocalPrice(selling);
    }
  }, [routesChanges, selling, row.userId, row.mccmnc]);
  

  const handleBlur = () => {
    if (localPrice === '' || localPrice === null) return;
  
    const newPrice = Number(localPrice);
  
    let block;
    if (isMultiselector.includes(parseInt(row.userId))) {
      // Aplica el nuevo precio a todas las rutas del mismo país
      block = usersPricelist[row.userId]
        .filter(({ mcc }) => mcc === row.mcc)
        .map(r => ({
          ...r,
          price: newPrice,
          oldPrice: usersPricelist[row.userId].find(({ mccmnc }) => mccmnc === r.mccmnc)?.price,
          change: 'price'
        }));
    } else {
      block = [{
        ...row,
        price: newPrice,
        oldPrice: usersPricelist[row.userId].find(({ mccmnc }) => mccmnc === row.mccmnc)?.price,
        change: 'price'
      }];
    }
  
    const changesUniqs = routesChanges.filter(
      ({ mccmnc }) => !block.find(r => r.mccmnc === mccmnc)
    );
  
    const changes = [...changesUniqs, ...block].filter(
      r => r.oldPrice !== r.price
    );
  
    setRoutesChanges(changes);
  };
  

  return (
    <InputNumber
      size="small"
      value={localPrice}
      min={0}
      step={0.0001}
      precision={4}
      onChange={value => setLocalPrice(value === null ? '' : value)}
      onBlur={handleBlur}
      onPressEnter={handleBlur}
      disabled={row.userId !== `${userIdEditing}`}
    />
  );
};

export default Selling;
